import { DiscountLine } from "./DiscountLine";
import { HeaderLine } from "./HeaderLine";
import { HeaderPaywallCustomizationLine } from "./HeaderPaywallCustomizationLine";
import { RegularPriceLine } from "./RegularPriceLine";
import { SubtotalLine } from "./SubtotalLine";
import { TaxLine } from "./TaxLine";

export const Lines = Object.assign(
  {},
  {
    DiscountLine,
    HeaderLine,
    HeaderPaywallCustomizationLine,
    RegularPriceLine,
    SubtotalLine,
    TaxLine,
  },
);
